var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wpay",
    attrs: {
      "id": "wpay"
    }
  }, [_c('form', {
    ref: "form",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "action": _vm.url,
      "method": "post",
      "target": _vm.target
    }
  }, _vm._l(_vm.params, function (value, key) {
    return _c('input', {
      key: key,
      attrs: {
        "type": "hidden",
        "name": key
      },
      domProps: {
        "value": value
      }
    });
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }